var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"onboarding-welcome inside-container onboarding active\"><img" + (jade.attr("src", require('./rent-app-logo-copy.svg'), true, true)) + " width=\"70\" alt=\"Rent Application\"><h2>Welcome to Rent Application</h2><h3>Want some help getting started? Give us a call:</h3><br><h2 ng-if=\"user_type === 'landlord'\">(312) 500-3121</h2><h2 ng-if=\"user_type != 'landlord'\">(872) 588-0377</h2><h3>or</h3><a ng-if=\"user_type === 'landlord'\" href=\"https://calendly.com/rrusso/introduction/\" target=\"_blank\" ng-click=\"$close('start')\" class=\"onboard-button get-started\">Click here to schedule a call</a><a ng-if=\"user_type != 'landlord'\" href=\"https://calendly.com/rrusso/introduction/\" target=\"_blank\" ng-click=\"$close('start')\" class=\"onboard-button get-started\">Click here to schedule a call</a><a href=\"#\" ng-click=\"$close('skip')\" class=\"onboard-skip\">Skip</a></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/forms/welcomeModal.jade
// module id = 762
// module chunks = 0